import { HttpService } from '@/utils/http/index'
import { joinParams } from '@/utils/index'

const $http = new HttpService()

// 获取渠道列表：type 有值返回 h5，mini_program 渠道，否则不返回
export const getChannelList = (params:object = {}) => $http.get('/dsapi/trade/channel_info', { ...params, type: 1 })

// 获取销售渠道列表
export const getSaleChannelList = (params:object = { type: 2 }) => $http.get('/dsapi/trade/channel_sale_list', params)

// 获取渠道配置信息
export const getChannelConfig = () => $http.get('/admin/channel/getChannelConfigData')

// 发送验证码，无需手机号，后台根据登录用户自动查找绑定手机号
export const sendCode = () => $http.get('/admin/channel/sendYzm')

// 获取密钥
export const getSecret = (code:string) => $http.get('/admin/channel/getApikey', { code })

// 获取渠道分组列表
export const getGroupList = (params: object = {}) => $http.get('/dsapi/trade/get_channel_group', params)

// 获取渠道分组详情
export const getGroupDetail = (group_id: any) => $http.get('/dsapi/trade/get_channel_group_details', { group_id })

// 保存渠道分组
export const saveGroup = (data: object) => $http.get('/dsapi/trade/add_edit_group', data)

// 删除渠道分组
export const delGroup = (group_id: any) => $http.get('/dsapi/trade/del_group', { group_id })

/**
 * 获取特殊开放的品牌/商品
*/
export const getSpecialOpenBrand = () => $http.get('/channel/special_open_list')

/**
 * 获取渠道开放详情（获取指定渠道已开放特殊品牌/商品）
*/
export const getChannelOpenBrand = ({ channel_id, type, channel_genre }) => $http.get('/dsapi/trade/channel_details', { channel_id, type, channel_genre })


/**
 * 保存渠道屏蔽/开放信息
*/
export const saveShieldOrOpen = ({ channel_id, type, channel_genre }) => $http.get('/dsapi/trade/shield_goods', { channel_id, type, channel_genre })

/**
 * 获取指定渠道周/月报数据
 * type：1-周，2-月
 * channel_no： 渠道号
*/
export const getChannelPosterApi = (type: number, channel_no: string) => $http.get('/calculation/Datawarehouse/getChannelRanking', { type, channel_no })

// 获取渠道付款配置列表
export const getChannelRechargeSettingListApi = (channel_id: string) => $http.get('/channel/zsPaymentList', { channel_id })

// 保存渠道付款配置
export const saveChannelRechargeSettingApi = (data: object) => $http.post('/channel/zsPaymentSave', data)

// 获取销售为渠道用户充值记录列表
export const getChannelUserRechargeListApi = (params: object) => $http.get('/port/user_coupon/coupon_bind_list', params)

// 保存销售为渠道用户充值
export const saveChannelUserRechargeApi = (data: object) => $http.post('/port/user_coupon/coupon_bind_msg_add', data, true)

// 获取销售为渠道用户充值失败记录列表
export const getChannelUserRechargeFailListApi = (id: number) => $http.get('/port/user_coupon/coupon_bind_info', { id })
// 根据专题ID获取专题图片
export const getTopicDetailApi = (id: number) => $http.post('/data/get_active_img', { id })

// 获取渠道分组配置品牌/商品折扣记录
export const getGroupDiscountLogApi = (params: object) => $http.get('/channel/batch_pricing_lists', params)

// 获取预付款变动信息
export const getYufkConsumerApi = (params: object) => $http.get('/admin/user/yufk_consumer', params)

/************************************************************ 渠道用户绑卡 - begin ******************************************************************/
/**
 * 获取绑定申请列表
 * @param sale_channel 销售渠道 （选填）
 * @param submit_time 提交时间 （选填）
 * @param audit_time 审核时间 （选填）
 * @param audit_status 审核状态 （选填）
 */
export const getBindApplyListApi = (params: object = {}) => $http.get('/couponBatch/getBatchList', params)

/**
 * 添加绑定申请前进行数据校验
 * @param file 文件 （必填）
 * @param sale_channel 销售渠道 （必填）
 * @param yd_user 审批人 （必填）
 * @param issue_method 是否发短信 （必填）
 * @param content 短信内容：0-否，1-是 （必填）
 * @param sms_sign 短信签名 （必填）
 */
export const checkBindApplyApi = (data: object = {}) => $http.post('/couponBatch/validateImportDataOnly', data, true)

/**
 * 添加绑定申请
 * @param file 文件 （必填）
 * @param sale_channel 销售渠道 （必填）
 * @param yd_user 审批人 （必填）
 * @param issue_method 是否发短信 （必填）
 * @param content 短信内容：0-否，1-是 （必填）
 * @param sms_sign 短信签名 （必填）
 */
export const saveBindApplyApi = (data: object = {}) => $http.post('/couponBatch/importSend', data, true)

/**
 * 获取绑定详情接口
 * @param batch_id 申请ID （必填）
 */
export const getBindApplyDetailApi = (batch_id: any) => $http.get('/couponBatch/getBatchDetail', { batch_id })

/**
 * 获取短信签名列表
 */
export const getSmsSignListApi = (params: object = {}) => $http.get('/couponBatch/get_sms_info', params)

/**
 * 删除绑定申请
 * @param batch_id 申请ID （必填）
 */
export const delBindApplyApi = (batch_id: any) => $http.post('/couponBatch/delBatch', { batch_id })

/**
 * 提取券码
 * @param batch_id 申请ID （必填）
 * @param phone 手机号 （必填）
 * @param code 验证码 （必填）
 */
export const extractBindCodeApi = (params: object = {}) => $http.get('/couponBatch/checkYzm', params)
/************************************************************ 渠道用户绑卡 - end ******************************************************************/

